export default {
  en: {
    searchBy: 'Search by',
    filters: {
      label: 'Title',
      name: 'ID (name)',
      type: 'Type',
      id: 'Internal ID',
    },
  },
  es: {
    searchBy: 'Buscar por',
    filters: {
      label: 'Título',
      name: 'ID (name)',
      type: 'Tipo',
      id: 'Id interno',
    },
  },
  fr: {
    searchBy: 'Rechercher par',
    filters: {
      label: 'Titre',
      name: 'ID (nom)',
      type: 'Type',
      id: 'ID interne',
    },
}

};
